import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AuthState } from "../../types/api";
import { User } from "../../types/users";

const token = sessionStorage.getItem("access");

const initialState: AuthState = {
  user: null,
  isAuthenticated: !!token,
  token: token,
  loading: false,
  error: null,
  signupSuccess: false,
  forgotPasswordLoading: false,
  forgotPasswordError: null,
  forgotPasswordSuccess: false,
  setPasswordLoading: false,
  setPasswordError: null,
  setPasswordSuccess: false,
  
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (
      state,
      action: PayloadAction<{ email: string; password: string }>
    ) => {
      // This action will be handled by the saga
    },
    register: (
      state,
      action: PayloadAction<{
        contant_no: string;
        email: string;
        first_name: string;
        last_name: string;
        organization: string;
        password: string;
        password2: string;
      }>
    ) => {
      // This action will be handled by the saga
    },
    loginStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    registerStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    loginSuccess: (state, action: PayloadAction<{ user: User }>) => {
      state.loading = false;
      state.user = action.payload.user;
      state.isAuthenticated = true;
      state.signupSuccess = false;
      state.token = sessionStorage.getItem("access");
    },
    registerSuccess: (state, action: PayloadAction<{ user: User }>) => {
      state.loading = false;
      state.user = action.payload.user;
      state.isAuthenticated = false;
      state.signupSuccess = true;
    },
    loginFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
      state.signupSuccess = false;
    },
    registerFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
      state.signupSuccess = false;
    },
    logout: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      state.signupSuccess = false;
      state.token = null;
      sessionStorage.removeItem("access");
      sessionStorage.removeItem("refresh");
    },
    clearError: (state) => {
      state.error = null;
      state.signupSuccess = false;
    },
    forgotPassword: (state, action: PayloadAction<{ email: string }>) => {
      // This action will be handled by the saga
    },
    forgotPasswordStart: (state) => {
      state.forgotPasswordLoading = true;
      state.forgotPasswordError = null;
      state.forgotPasswordSuccess = false;
    },
    forgotPasswordSuccess: (state) => {
      state.forgotPasswordLoading = false;
      state.forgotPasswordSuccess = true;
    },
    forgotPasswordFailure: (state, action: PayloadAction<string>) => {
      state.forgotPasswordLoading = false;
      state.forgotPasswordError = action.payload;
      state.forgotPasswordSuccess = false;
    },
    clearForgotPassword: (state) => {
      state.forgotPasswordLoading = false;
      state.forgotPasswordError = null;
      state.forgotPasswordSuccess = false;
    },
    setPassword: (
      state,
      action: PayloadAction<{ userId: string; token: string; password: string }>
    ) => {
      // This action will be handled by the saga
    },
    setPasswordStart: (state) => {
      state.setPasswordLoading = true;
      state.setPasswordError = null;
      state.setPasswordSuccess = false;
    },
    setPasswordSuccess: (state) => {
      state.setPasswordLoading = false;
      state.setPasswordSuccess = true;
    },
    setPasswordFailure: (state, action: PayloadAction<string>) => {
      state.setPasswordLoading = false;
      state.setPasswordError = action.payload;
      state.setPasswordSuccess = false;
    },
    clearSetPassword: (state) => {
      state.setPasswordLoading = false;
      state.setPasswordError = null;
      state.setPasswordSuccess = false;
    },
  },
});

export const {
  login,
  register,
  loginStart,
  registerStart,
  loginSuccess,
  registerSuccess,
  loginFailure,
  registerFailure,
  logout,
  clearError,
  forgotPassword,
  forgotPasswordStart,
  forgotPasswordSuccess,
  forgotPasswordFailure,
  clearForgotPassword,
  setPassword,
  setPasswordStart,
  setPasswordSuccess,
  setPasswordFailure,
  clearSetPassword,
} = authSlice.actions;
export default authSlice.reducer;
